/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAxMlYxMS4yMjEySDEyVjEySDJaTTIgOS42OTc5NFY4LjkxOTE3SDguODgyMzFWOS42OTc5NEgyWk0yIDcuMzg3NzZWNi42MDg5OUgxMlY3LjM4Nzc2SDJaTTIgNS4wODU3VjQuMzA2OTNIOC44ODIzMVY1LjA4NTdIMlpNMiAyLjc3ODc3VjJIMTJWMi43Nzg3N0gyWiIgZmlsbD0iYmxhY2siLz48L3N2Zz4=";